var exports = {
  "kL": "xf0b3b88a--fc9015--container",
  "wx": "xf0b3b88a--fc9015--header",
  "AS": "xf0b3b88a--fc9015--item",
};

module.exports = exports;
